export { default } from './categories-list';
